import {request} from '../services/request';
import {expenseConstants} from '../constants';
import {backendEndpoints} from '../../api';
import {apiHelpers} from '../../utils/helpers';
import {expenseAgentTypeConstants} from '../../constants';

const errorHandlerProps = {disableAlert: true};

const {getUrl} = apiHelpers;

const getExpenses = ({query, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_EXPENSES,
      query,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getExpense = ({id, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: getUrl(backendEndpoints.GET_EXPENSE, {id}),
      successCallback: (data) => {
        dispatch({
          type: expenseConstants.GET_EXPENSE,
          data
        });
        successCallback?.(data);
      },
      errorCallback
    });
  }
}

const getExpenseAttachment = ({id, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: getUrl(backendEndpoints.GET_EXPENSE_ATTACHMENT, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getExpenseRelatedInvoices = ({id, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: getUrl(backendEndpoints.GET_EXPENSE_RELATED_INVOICES, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const updateExpense = ({id, data, propertyName, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    const endpoint = {
      'expense_type': backendEndpoints.PUT_EXPENSE_UPDATE_EXPENSE_TYPE
    }[propertyName] || backendEndpoints.PUT_EXPENSE_UPDATE;

    request.put({
      dispatch,
      url: getUrl(endpoint, {id}),
      data,
      successCallback,
      errorCallback
    });
  }
}

const approveExpense = ({id, data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.put({
      dispatch,
      url: getUrl(backendEndpoints.PUT_EXPENSE_APPROVE, {id}),
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const reassignExpense = ({id, data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.put({
      dispatch,
      url: getUrl(backendEndpoints.PUT_EXPENSE_REASSIGN, {id}),
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const reopenExpense = ({id, data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.patch({
      dispatch,
      url: getUrl(backendEndpoints.PATCH_EXPENSE_EDIT_REVIEW, {id}),
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const rejectExpense = ({id, data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.put({
      dispatch,
      url: getUrl(backendEndpoints.PUT_EXPENSE_REJECT, {id}),
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getBatchExpenses = ({data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.post({
      dispatch,
      url: backendEndpoints.POST_EXPENSES_BATCH,
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const downloadZipInvoices = ({query, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_EXPENSES_ZIP_INVOICES,
      query,
      successCallback,
      errorCallback,
      errorHandlerProps,
    });
  }
}

const exportExpenses = ({query, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_EXPENSES_EXPORT,
      query,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const openExpenseAgentChat = ({variant = expenseAgentTypeConstants.ADD_NEW_EXPENSE, query = {}} = {}) => {
  return (dispatch) => {
    dispatch({
      type: expenseConstants.OPEN_EXPENSE_AGENT_CHAT,
      data: { variant, query },
    });
  }
}

const closeExpenseAgentChat = () => {
  return (dispatch) => {
    dispatch({
      type: expenseConstants.CLOSE_EXPENSE_AGENT_CHAT,
    });
  }
}

export const expenseActions = {
  getExpenses,
  getExpense,
  getExpenseAttachment,
  getExpenseRelatedInvoices,
  getBatchExpenses,

  approveExpense,
  reassignExpense,
  rejectExpense,
  reopenExpense,
  updateExpense,
  downloadZipInvoices,
  exportExpenses,

  openExpenseAgentChat,
  closeExpenseAgentChat,
};
